
export function getKennzahlenVerfuegbar(kennzahlen_berechnet: any, jahrFilter?: number) {
    // console.log(kennzahlen_berechnet);
    const found: any = {};
    Object.keys(kennzahlen_berechnet).forEach((jahr: string) => {
        if (jahrFilter > 0 && +jahr !== jahrFilter) {
            return;
        }
        Object.keys(kennzahlen_berechnet[jahr]).forEach((k: string) => {
            const kzb = kennzahlen_berechnet[jahr][k];
            // console.log(k, kzb);
            if (kzb !== undefined && !isNaN(kzb)) {
                found[k] = 2;
            } else {
                // found[k] = 1;
            }
        });
    });
    // console.log('KZ Found: ', found);
    return found;
}